/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { useChatflows } from 'conversations-thread-data/chatflows/hooks/useChatflows';
import ChatflowContextUpdate from './ChatflowContextUpdate';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChatflowContextUpdateContainer = props => {
  const {
    chatflowId
  } = props;
  const {
    asyncChatflow
  } = useChatflows({
    chatflowId
  });
  if (isLoading(asyncChatflow)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200,
      use: "on-shade"
    });
  }
  const chatflow = getData(asyncChatflow);
  const {
    channelInstance
  } = chatflow || {};
  const chatflowName = channelInstance && channelInstance.name || '';
  return /*#__PURE__*/_jsx(ChatflowContextUpdate, Object.assign({
    chatflowName: chatflowName
  }, props));
};
ChatflowContextUpdateContainer.displayName = 'ChatflowContextUpdateContainer';
export default ChatflowContextUpdateContainer;